module.exports = __webpack_public_path__ + "img/guide-en-1.db63e910.png";